import { child, onValue, remove, set } from "firebase/database";
import _ from "lodash";
import { watch } from "vue";
import { bucket, isOfflineBoot, offlineBucketNames } from "~/services/storage/offlineBuckets";
import { loadSingleRow, waitForFirstRTDBSettle, isMainCashierRuntime } from "~/services/bootstrap/layerBHelpers";

// `pos_runtime_{storeId}` DB stores two independent rows:
//   key `soldout`   → soldout map
//   key `splitBill` → split-bill map (owned by pos.billsNumber)
// Each store reads/writes its own row — no merge logic needed.
const SOLDOUT_KEY = "soldout";

function getRuntimeBucket() {
    const sid = useAuthStore().storeId;
    if (!sid) return null;
    return bucket(offlineBucketNames.runtime(String(sid)));
}

export const usePosSoldoutStore = defineStore("soldout", () => {

    const soldout = ref({});
    const loaded = ref(false);

    const fetchSnapshot = () => {
        const soldoutRef = useRealtimeDatabase().soldoutRef();
        onValue(soldoutRef, (snapshot) => {

            soldout.value = snapshot.val() || {};
            loaded.value = true;
        });
    };

    const updateProductSoldout = (subitemId: string, soldoutOneSubItemValue: boolean) => {

        const soldoutRef = useRealtimeDatabase().soldoutRef()
        const childRef = child(soldoutRef, subitemId.toString())
        if(soldoutOneSubItemValue){
            set(childRef, soldoutOneSubItemValue);
        }else{
            remove(childRef);
        }

    };

    const persistToIDB = _.debounce(() => {
        // Only the Main Cashier owns the runtime IDB mirror — skip on
        // terminal / 2nd cashier / readonly.
        if (!isMainCashierRuntime()) return;
        const b = getRuntimeBucket();
        if (!b) return;
        void b.set(SOLDOUT_KEY, soldout.value);
    }, 300);

    async function bootOnline() {
        fetchSnapshot();
        watch(soldout, () => persistToIDB(), { deep: true });
        await waitForFirstRTDBSettle(useRealtimeDatabase().soldoutRef());
        loaded.value = true;
    }

    async function bootOffline() {
        const cached = await loadSingleRow<Record<string, any>>(getRuntimeBucket(), SOLDOUT_KEY);
        if (cached) soldout.value = cached;
        loaded.value = true;
        fetchSnapshot();
        watch(soldout, () => persistToIDB(), { deep: true });
    }

    const init = async () => {
        if (isOfflineBoot()) return bootOffline();
        return bootOnline();
    }

    return {
        name: "soldout",
        soldout,
        loaded,
        fetchSnapshot,
        updateProductSoldout,
        init,
        bootOnline,
        bootOffline,
    }
})
